import script from "./LicencasView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LicencasView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__